var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-modal',{attrs:{"show":_vm.show,"on-close":_vm.close}},[_c('v-modal-header',{attrs:{"title":_vm.title,"on-close":_vm.close}}),_c('v-modal-body',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('v-button-holder',{attrs:{"align":"right"}},_vm._l((_vm.buttons),function(button){return _c('v-button',{key:button.label,attrs:{"click":() => {
          _vm.Vue.set(button, 'spinning', true)
          button.click();
        },"spinning":button.spinning,"label":button.label}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }